import {
  Box,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

import { useNavigate } from "react-router-dom";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { DaysLeft, decodeTimeLine } from "../../Dashboard/EventList/TaskCard";
import moment from "moment";

import { StyledTextarea } from "../../common/Textareas";
import { axiosInstance } from "../../../utils/networking";
import ThriveModal from "../../common/ThriveModal";
import BusinessActionPlanEdit from "./BusinessActionPlanEdit";
import ThriveTitle from "../../common/ThriveTitle";
import {
  BusinessActionPlanType,
  defaultBusinessActionPlan,
} from "../../../interfaces";
import BusinessActionPlanCard from "./BusinessActionPlanCard";
import { StyledButtonMain } from "../../common/Buttons";

const compareByDate = (a: any, b: any) => {
  return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
};

type BusinessActionPlanProps = {
  setCardOpen: (open: boolean) => void;
  theCase: any;
  activity: any[];
  dataFlag: boolean;
  setDataFlag: (flag: boolean) => void;
};

const BusinessActionPlan: React.FC<BusinessActionPlanProps> = ({
  setCardOpen,
  theCase,
  activity,
  dataFlag,
  setDataFlag,
}) => {
  const [actionPlanModalOpen, setActionPlanModalOpen] = React.useState(false);
  const [selectedActionPlan, setSelectedActionPlan] =
    useState<BusinessActionPlanType>({
      ...defaultBusinessActionPlan,
      case_id: theCase._id,
    });
  const [actionPlans, setActionPlans] = useState<BusinessActionPlanType[]>([]);

  useEffect(() => {
    axiosInstance.get(`/actionPlan?case_id=${theCase._id}`).then((res) => {
      if (res.status === 200) {
        let actionPlans = res.data.action_plans;
        actionPlans.map((action: any) => {
          if (action["status"] === "completed") {
            action["daysLeft"] = 10000;
          } else {
            action["daysLeft"] =
              typeof decodeTimeLine(action.timeLine) === "number"
                ? moment(action["startDate"])
                    .add(decodeTimeLine(action.timeLine), "days")
                    .diff(moment(), "days")
                : 9999;
          }
        });

        let sortedActionPlans = actionPlans.sort(
          (a: any, b: any) => a.daysLeft - b.daysLeft
        );
        console.log("sorted action plan", sortedActionPlans);
        setActionPlans(sortedActionPlans);
      } else {
        console.log("API Error at getting survey result");
      }
    });
  }, []);

  const handleClose = () => {
    setCardOpen(false);
  };

  const handleSave = () => {
    axiosInstance
      .post(`/actionPlan`, {
        activity_type: "Business Action Plan",
        action_plan: selectedActionPlan,
      })
      .then((res) => {
        if (res.status === 200) {
          setCardOpen(false);
          setDataFlag(!dataFlag);
        } else {
          console.log("API Error");
        }
      });
  };

  const handleDelete = () => {
    axiosInstance
      .post(`/actionPlan`, {
        activity_type: "Business Action Plan",
        action_plan: { ...selectedActionPlan, status: "deleted" },
      })
      .then((res) => {
        if (res.status === 200) {
          setCardOpen(false);
          setDataFlag(!dataFlag);
        } else {
          console.log("API Error");
        }
      });
  };

  const handleComplete = () => {
    axiosInstance
      .post(`/actionPlan`, {
        activity_type: "Business Action Plan",
        action_plan: { ...selectedActionPlan, status: "completed" },
      })
      .then((res) => {
        if (res.status === 200) {
          setCardOpen(false);
          setDataFlag(!dataFlag);
        } else {
          console.log("API Error");
        }
      });
  };

  const handleExtend = () => {
    axiosInstance
      .post(`/actionPlan`, {
        activity_type: "Business Action Plan",
        action_plan: {
          ...selectedActionPlan,
          timeLine: selectedActionPlan["timeLine"]
            ? `${parseInt(selectedActionPlan["timeLine"]) + 60} days`
            : "60 days",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setCardOpen(false);
          setDataFlag(!dataFlag);
        } else {
          console.log("API Error");
        }
      });
  };

  const handleNewClose = () => {
    console.log("Check content before close", selectedActionPlan);
  };

  // const handleResourceSelection = () => {
  //   // console.log("Resource Selection");
  //   let simplifiedActionPlan = actionPlan.filter((item) => {
  //     return item.businessObjective;
  //   });
  //   axiosInstance
  //     .post(`/actionPlan`, {
  //       activity_type: "Business Action Plan",
  //       action_plan: {
  //         content: simplifiedActionPlan,
  //         case_id: props.case._id,
  //         _id: existedActionPlanID,
  //       },
  //     })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         navigate(
  //           `/dashboard/resources?case_id=${props.case._id}&action_plan_id=`
  //         );

  //         // console.log(res.data);
  //         // props.setCardOpen(false);
  //         // props.setDataFlag(!props.dataFlag);
  //       } else {
  //         console.log("API Error");
  //       }
  //     });
  // };

  // const handleB2BSelection = () => {
  //   // console.log("B2B Selection");
  //   let simplifiedActionPlan = actionPlan.filter((item) => {
  //     return item.businessObjective;
  //   });
  //   axiosInstance
  //     .post(`/actionPlan`, {
  //       activity_type: "Business Action Plan",
  //       action_plan: {
  //         content: simplifiedActionPlan,
  //         case_id: props.case._id,
  //         _id: existedActionPlanID,
  //       },
  //     })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         navigate(
  //           `/dashboard/providers?case_id=${props.case._id}&action_plan_id=`
  //         );

  //         // console.log(res.data);
  //         // props.setCardOpen(false);
  //         // props.setDataFlag(!props.dataFlag);
  //       } else {
  //         console.log("API Error");
  //       }
  //     });
  // };

  // const extendActionPlan = (index: number) => {
  //   let tempArray = [...actionPlan];
  //   let tempObject = tempArray[index];
  //   tempObject["timeLine"] = tempObject["timeLine"]
  //     ? `${parseInt(tempObject["timeLine"]) + 60} days`
  //     : "60 days";
  //   let simplifiedActionPlan = tempArray.filter((item) => {
  //     return item.businessObjective;
  //   });
  //   axiosInstance
  //     .post(`/actionPlan`, {
  //       activity_type: "Business Action Plan",
  //       action_plan: {
  //         content: simplifiedActionPlan,
  //         case_id: props.case._id,
  //         _id: existedActionPlanID,
  //       },
  //     })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         // console.log(res.data);
  //         props.setCardOpen(false);
  //         props.setDataFlag(!props.dataFlag);
  //       } else {
  //         console.log("API Error");
  //       }
  //     });
  // };

  const openEditModal = (actionPlan: BusinessActionPlanType) => {
    setSelectedActionPlan({
      ...actionPlan,
      case_id: actionPlan.case_id || theCase._id,
    });
    setActionPlanModalOpen(true);
  };

  return (
    <>
      <ThriveTitle
        title={"Business Action Plan(s)"}
        setOpen={setCardOpen}
      ></ThriveTitle>

      <Box sx={{ overflowY: "scroll", height: { xs: 470, md: 520 } }}>
        {actionPlans.map((actionPlan: any, index: number) => {
          return (
            <BusinessActionPlanCard
              key={index}
              enableEdit={false}
              actionPlan={actionPlan}
              setActionPlan={() => {}}
              onEdit={openEditModal}
            />
          );
        })}

        <Stack
          sx={{
            bottom: 20,
            width: "100%",
            justifyContent: "center",
            position: "fixed",
          }}
          spacing={2}
          direction={"row"}
        >
          <StyledButtonMain
            onClick={() => {
              setActionPlanModalOpen(true);
            }}
          >
            Add Business Objective
          </StyledButtonMain>
          <StyledButtonMain variant="contained" onClick={handleClose}>
            Close
          </StyledButtonMain>
        </Stack>
      </Box>
      <ThriveModal
        open={actionPlanModalOpen}
        setOpen={setActionPlanModalOpen}
        closeByClick={false}
        contentComponent={
          <BusinessActionPlanEdit
            setOpen={setActionPlanModalOpen}
            actionPlan={selectedActionPlan}
            setActionPlan={setSelectedActionPlan}
            handleSave={handleSave}
            handleComplete={handleComplete}
            handleExtend={handleExtend}
            handleDelete={handleDelete}
            handleNewClose={handleNewClose}
          />
        }
      ></ThriveModal>
    </>
  );
};

export default BusinessActionPlan;
